export default __webpack_public_path__ + "static/media/ic-sm-grazing-2.29275167.svg";